import Vue from "vue";
Vue.component("summary-details-vue", {
  mounted() {
    const accordionItems = this.$el.querySelectorAll('.summary-accordion__item');
    accordionItems.forEach((item) => {
      const title = item.querySelector(".summary-accordion__title button");
      const content = item.querySelector(".summary-accordion__content");
      const svgIcon = title.querySelector("button svg");
      title.addEventListener("click", () => {
        content.classList.toggle("active");
        svgIcon.classList.toggle("rotate-down", !content.classList.contains("active"));
        svgIcon.classList.toggle("rotate-up", content.classList.contains("active"));
      });
    });
  },
});
